import type { ComponentPropsWithoutRef } from "react";

import type { SortDirection } from "@/types/common.types";

type ProductTextFieldName =
  | "name"
  | "category"
  | "brand"
  | "uom"
  | "currentPrice"
  | "lowStockThreshold";
type ProductBooleanFieldName = "isMedication" | "requiresPrescription";

interface ProductTextFieldConfig {
  name: ProductTextFieldName;
  label: string;
  placeholder: string;
  description?: string;
  className?: string;
  inputProps?: Pick<
    ComponentPropsWithoutRef<"input">,
    "type" | "inputMode" | "min" | "step" | "maxLength"
  >;
}

interface ProductBooleanFieldConfig {
  name: ProductBooleanFieldName;
  label: string;
  description: string;
}

export const PRODUCTS_PAGE_SIZE = 12;
export const PRODUCT_SEARCH_DEBOUNCE_MS = 350;
export const DEFAULT_PRODUCT_SORT_DIRECTION: SortDirection = "asc";

export const CATALOG_PRODUCTS_MANAGE_PERMISSION = "catalog:products:manage";
export const CATALOG_PRODUCTS_QUERY_KEY = ["catalog-products"] as const;
export const CATALOG_PRODUCT_CATEGORIES_QUERY_KEY = [
  "catalog-product-categories",
] as const;
export const CATALOG_PRODUCT_BRANDS_QUERY_KEY = [
  "catalog-product-brands",
] as const;

export const PRODUCT_FORM_TEXT_FIELDS = [
  {
    name: "name",
    label: "Nombre",
    placeholder: "Paracetamol 500 mg",
  },
  {
    name: "brand",
    label: "Marca",
    placeholder: "Genérico",
  },
  {
    name: "category",
    label: "Categoría",
    placeholder: "Analgésicos",
    description: "Opcional. Hasta 120 caracteres.",
  },
  {
    name: "uom",
    label: "Unidad de medida",
    placeholder: "CAJA",
    description: "Opcional. Hasta 40 caracteres (ej. CAJA, UNIDAD, FRASCO).",
    inputProps: {
      maxLength: 40,
    },
  },
  {
    name: "currentPrice",
    label: "Precio actual",
    placeholder: "0.00",
    description: "Precio de venta en BOB.",
    className: "sm:col-span-2",
    inputProps: {
      type: "number",
      inputMode: "decimal",
      min: "0",
      step: "0.01",
    },
  },
  {
    name: "lowStockThreshold",
    label: "Alerta de bajo stock",
    placeholder: "5",
    description:
      "Opcional. Vacío usa el umbral global (5 unidades). Número entero mayor o igual a 1.",
    className: "sm:col-span-2",
    inputProps: {
      type: "number",
      inputMode: "numeric",
      min: "1",
      step: "1",
    },
  },
] satisfies ProductTextFieldConfig[];

export const PRODUCT_FORM_BOOLEAN_FIELDS = [
  {
    name: "isMedication",
    label: "Medicamento",
    description: "Marca el producto como medicamento.",
  },
  {
    name: "requiresPrescription",
    label: "Requiere receta",
    description: "Muestra la alerta de receta en el catálogo.",
  },
] satisfies ProductBooleanFieldConfig[];
